import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';

const BlockSumBonus = ({formik}) => {
    const [sumBonus, setSumBonus] = React.useState(false);
    const classes = useStyles();
  
    return (
        <div>
            <BlockTitleGroup setShowBlock={setSumBonus} showBlock={sumBonus} title="Сумма бонуса" />
            {
                sumBonus &&
                <div>
                    <div className={classes.flex}>
                        <label htmlFor="min_sum_deposit" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                            <span className={classes.helper}>Минимальная сумма депозита</span>
                            <input 
                                type="number" 
                                name="min_sum_deposit" 
                                id="min_sum_deposit" 
                                className={classes.text}
                                value={formik.values.min_sum_deposit} 
                                onChange={(v) => formik.setFieldValue('min_sum_deposit', v.target.value)}
                            />
                        </label>
                        <label htmlFor="max_sum_deposit" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Максимальная сумма депозита</span>
                            <input 
                                type="number" 
                                name="max_sum_deposit" 
                                id="max_sum_deposit" 
                                className={classes.text} 
                                value={formik.values.max_sum_deposit} 
                                onChange={(v) => formik.setFieldValue('max_sum_deposit', v.target.value)}/>
                        </label>
                    </div>
                    <div className={classes.flex}>
                        <label htmlFor="fix_size_bonus" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                            <span className={classes.helper}>Макс. сумма бонуса</span>
                            <input 
                                type="number" 
                                name="fix_size_bonus" 
                                id="fix_size_bonus" 
                                className={classes.text}
                                value={formik.values.fix_size_bonus} 
                                onChange={(v) => formik.setFieldValue('fix_size_bonus', v.target.value)}
                            />
                        </label>
                        <label htmlFor="wager" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Коэффициент для фиксированного бонуса</span>
                            <input 
                                type="number" 
                                name="wager" 
                                id="wager" 
                                className={classes.text} 
                                value={formik.values.wager} 
                                onChange={(v) => formik.setFieldValue('wager', v.target.value)}/>
                        </label>
                    </div>
                    <div className={classes.flex}>
                        <label htmlFor="percent_of_deposit" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                            <span className={classes.helper}>Процент от суммы депозита</span>
                            <input 
                                type="number" 
                                name="percent_of_deposit" 
                                id="percent_of_deposit" 
                                className={classes.text}
                                value={formik.values.percent_of_deposit} 
                                onChange={(v) => formik.setFieldValue('percent_of_deposit', v.target.value)}
                            />
                        </label>
                        <label htmlFor="wager_percent" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mr12)}>
                            <span className={classes.helper}>Коэффициент отыгрыша для бонуса процентах</span>
                            <input
                                type="number" 
                                name="wager_percent" 
                                id="wager_percent" 
                                className={classes.text} 
                                value={formik.values.wager_percent} 
                                onChange={(v) => formik.setFieldValue('wager_percent', v.target.value)}/>
                        </label>
                        <label htmlFor="max_size_bonus_of_deposit" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Макс. размер бонуса от процента депозита</span>
                            <input
                                type="number" 
                                name="max_size_bonus_of_deposit" 
                                id="max_size_bonus_of_deposit" 
                                className={classes.text} 
                                value={formik.values.max_size_bonus_of_deposit} 
                                onChange={(v) => formik.setFieldValue('max_size_bonus_of_deposit', v.target.value)}/>
                        </label>
                    </div>                    
                </div>
            }
        </div>
    )
}

export default BlockSumBonus;